















import {
    defineComponent,
    onBeforeMount,
    onBeforeUnmount,
    onMounted,
    ref,
    computed,
    watch
} from "@vue/composition-api";
import { alarm, app, sensor } from "@/store";
import { configureOidc } from "@/store/services/security.service";
import { OidcAuth } from "vue-oidc-client/vue2";
import useIOSDetection from "@/utilities/useIOSDetection";
import { configureMessageHub } from "../plugins/messageHub";

export default defineComponent({
    setup(_, { root }) {
        sensor.GetData();

        const loading = ref<Boolean>(true);
        const container = ref<HTMLElement>();
        const error = computed(() => app.error);
        const statusReceived = ref(false);

        const delay = (ms: number) => new Promise(res => setTimeout(res, ms));

        const waitForStatus = async (timeoutMs = 15000): Promise<boolean> => {
            return await new Promise((resolve) => {
                const checkInterval = setInterval(() => {
                    if (statusReceived.value) {
                        clearInterval(checkInterval);
                        resolve(true);
                    }
                }, 300);

                setTimeout(() => {
                    clearInterval(checkInterval);
                    resolve(false);
                }, timeoutMs);
            });
        };

        const stopWatch = watch(() => alarm.alarmStatus, (val) => {
            if (val) {
                statusReceived.value = true;
                stopWatch(); // Stop watching after first valid status
            }
        });

        const logout = () => {
            configureOidc().then((oidc: OidcAuth) => {
                oidc.signOut().then(() => {
                    window.location.href = "/Identity/Account/Logout";
                }).catch(err => console.error('OIDC configuration or sign-out failed:', err));
            });
        };

        onBeforeMount(() => {
            app.showFooter = false;
        });
        onBeforeUnmount(() => {
            app.showFooter = true;
        });

        onMounted(async () => {
            const maxRetries = 3;
            let attempt = 0;
            let success = false;

            try {
                await configureMessageHub();
                console.log("Message hub configured");

                while (attempt < maxRetries && !success) {
                    statusReceived.value = false;

                    try {
                        console.log(`Attempt ${attempt + 1} of ${maxRetries}`);
                        await alarm.getStatus();

                        const received = await waitForStatus(15000);

                        if (received) {
                            success = true;
                            break;
                        } else {
                            console.warn("No status received within 30 seconds.");
                        }
                    } catch (e) {
                        console.warn(`Status call threw error:`, e);
                    }

                    attempt++;
                    if (attempt < maxRetries) {
                        console.warn("Retrying...");
                    }
                }
            } catch (e) {
                console.error("Message hub setup failed:", e);
                app.error = "Unable to initialize system.";
            }

            loading.value = false;

            if (!success) {
                app.error = "Gateway is not responding. Logging out...";
                setTimeout(() => logout(), 4000);
                setTimeout(() => { app.error = ""; }, 8000);
            }
        });

        const { showInstallMessage } = useIOSDetection();

        return {
            loading,
            container,
            error
        };
    }
});
